import { useMaintenance } from '@/context/MaintenanceContext'

export function MaintenanceBanner() {
	const { status } = useMaintenance()

	if (!status.banner_enabled) return null

	const message =
		status.message?.trim() ||
		'Scheduled maintenance is in progress. Some features may be unavailable.'

	return (
		<div
			className="shrink-0 border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-sm text-amber-900"
			role="alert"
		>
			{message}
		</div>
	)
}
